'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sign = require('babel-runtime/core-js/math/sign');

var _sign2 = _interopRequireDefault(_sign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _OrderItem = require('./OrderItem.js');

var _OrderItem2 = _interopRequireDefault(_OrderItem);

var _availability = require('availability');

var availability = _interopRequireWildcard(_availability);

var _Properties = require('../Properties.js');

var _Properties2 = _interopRequireDefault(_Properties);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _JsonTemplates = require('../JsonTemplates.js');

var _JsonTemplates2 = _interopRequireDefault(_JsonTemplates);

var _ChargeV2MenuFilter = require('./ChargeV2.MenuFilter.js');

var _ChargeV2MenuFilter2 = _interopRequireDefault(_ChargeV2MenuFilter);

var _ChargeV2Templates = require('./ChargeV2Templates');

var _ChargeV2Templates2 = _interopRequireDefault(_ChargeV2Templates);

var _wixRestaurantsJsSdk = require('wix-restaurants-js-sdk');

var _jsSha = require('js-sha1');

var _jsSha2 = _interopRequireDefault(_jsSha);

var _memoizeOne = require('memoize-one');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.getChargeType = function (params) {
    var charge = params.charge;
    var simplified = self.simplifyCharge(params);
    var type = _lodash2.default.get(simplified, 'type');
    var managerDiscountType = _Properties2.default.get(charge, 'managerDiscountType');
    if (type) {
        return type;
    } else if (managerDiscountType) {
        return managerDiscountType;
    }
};

self.isVariable = function (params) {
    var charge = params.charge;

    return !charge.operator;
};

self.isApplicable = function (params) {
    var charge = params.charge;
    var deliveryTime = params.deliveryTime;
    var deliveryType = params.deliveryType || "";
    var orderItems = params.orderItems || [];
    var source = params.source;
    var platform = params.platform;

    if (charge.state === 'closed') return false;

    return checkCondition({ condition: charge.condition, deliveryTime: deliveryTime, deliveryType: deliveryType,
        orderItems: orderItems, source: source, platform: platform });
};

self.isDisplayable = function (params) {
    var charge = params.charge;
    var deliveryTime = params.deliveryTime;
    var deliveryType = params.deliveryType || "";
    var orderItems = params.orderItems || [];
    var source = params.source;
    var platform = params.platform;

    if (charge.state === 'closed') return false;

    return checkCondition({ condition: charge.displayCondition, deliveryTime: deliveryTime, deliveryType: deliveryType,
        orderItems: orderItems, source: source, platform: platform });
};

self.calculateOperator = calculateOperator;
self.isApplicableItem = isApplicableItem;

self.calculateAmount = function (params) {
    var charge = params.charge;
    var orderItems = params.orderItems || [];
    var orderCharges = params.orderCharges || [];
    var extraCost = params.extraCost;

    if (!this.isApplicable(params)) return 0;

    return calculateOperator({ operator: charge.operator, orderItems: orderItems, orderCharges: orderCharges,
        extraCost: extraCost });
};

self.getTitle = function (params) {
    var charge = params.charge;
    var i18n = params.i18n;
    var defaultLocale = params.defaultLocale;

    return charge.title ? charge.title[i18n.getLocale()] || charge.title[defaultLocale] : '';
};

self.getDescription = function (params) {
    var charge = params.charge;
    var i18n = params.i18n;
    var defaultLocale = params.defaultLocale;

    return charge.description ? charge.description[i18n.getLocale()] || charge.description[defaultLocale] : '';
};

self.chargeIsTax = function (charge) {
    return charge.type == 'tax';
};

self.getItemsAffectedByDiscount = function (simpleDiscount, menu) {
    var idsFilter = _ChargeV2MenuFilter2.default.menuFilterToIdsFilter({ menuFilter: _lodash2.default.get(simpleDiscount, 'filters.menuFilter'), menu: menu });

    if (idsFilter.type === 'include') {
        return idsFilter.ids;
    }

    return _lodash2.default.uniq(_lodash2.default.flatten(_lodash2.default.compact(_lodash2.default.map(_lodash2.default.flatten(_lodash2.default.map(menu.sections, 'children')), 'itemIds'))));
};

self.setTitle = function (charge, newTitle, locale) {
    charge.title[locale] = newTitle;
    return charge;
};

self.setDescription = function (charge, newDescription, locale) {
    charge.description[locale] = newDescription;
    return charge;
};

self.setPercentDiscountValue = function (charge, newValue) {
    (_lodash2.default.find(charge.operator.numerators, { type: 'value' }) || {}).value = newValue;
    return charge;
};

self.getFullOrderCharge = function (_ref) {
    var orderCharge = _ref.orderCharge,
        menuFull = _ref.menuFull;

    var charge = _lodash2.default.find(menuFull.chargesV2, function (c) {
        return c.id === orderCharge.chargeId;
    });
    var description = charge.description ? { description: charge.description } : {};
    return (0, _extends3.default)({}, orderCharge, { type: charge.type, title: charge.title }, description);
};

self.simplifyCharge = function (_ref2) {
    var charge = _ref2.charge;

    charge = migrateOldTaxIfNeeded(charge);

    if (_Properties2.default.get(charge, 'deleted')) {
        return null;
    }

    var chargeValues = _JsonTemplates2.default.findMatchingTemplate(charge, _ChargeV2Templates2.default);

    if (!chargeValues) {
        return null;
    }

    var type = chargeValues.type;
    var params = chargeValues.params;

    // Migration from tip.v1 to tip.v2

    if (type === 'tipV1') {
        type = 'tip';
    }
    if (_lodash2.default.endsWith(type, 'Coupon')) {
        type = type.slice(0, -6);
    }

    var availability = params.availability,
        minPrice = params.minPrice,
        deliveryTypeConditions = params.deliveryTypeConditions,
        platformConditions = params.platformConditions,
        applyTo = params.applyTo,
        couponState = params.couponState,
        couponHashCode = params.couponHashCode;


    var data = {
        percent: params.percent,
        amount: params.amount
    };

    var filters = {
        deliveryType: _lodash2.default.fromPairs(_lodash2.default.map(deliveryTypeConditions, function (d) {
            return [d.deliveryType, true];
        })),
        platform: _lodash2.default.fromPairs(_lodash2.default.map(platformConditions, function (p) {
            return [p.platform, true];
        })),
        availability: availability,
        minPrice: minPrice || 0,
        coupon: {
            state: couponState === 'true',
            couponHashCode: couponHashCode
        }
    };

    // Menu filter: Use the one in the properties (if exists) since it is set to the correct
    // granularity (section/menu). Otherwise, rebuild from the applyTo field
    filters.menuFilter = _Properties2.default.get(charge, 'menuFilter');
    if (!filters.menuFilter && _lodash2.default.get(applyTo, 'ids')) {
        filters.menuFilter = _ChargeV2MenuFilter2.default.createDishesFilter({ ids: applyTo.ids });
    }

    // Create the simplified charge
    return cleanUp({
        type: type,
        id: params.id,
        title: params.title,
        description: params.description,
        disabled: params.state === 'closed',
        data: _lodash2.default.omitBy(data, _lodash2.default.isUndefined),
        filters: _lodash2.default.omitBy(filters, _lodash2.default.isUndefined),
        deleted: type === 'deletedDiscount'
    });
};

self.complicateCharge = function (_ref3) {
    var charge = _ref3.charge,
        menu = _ref3.menu,
        forceItemIds = _ref3.forceItemIds;
    var _charge$filters = charge.filters,
        filters = _charge$filters === undefined ? {} : _charge$filters;


    var deliveryTypeConditions = _lodash2.default.compact(_lodash2.default.map(filters.deliveryType, function (v, k) {
        return v ? { type: "order_delivery_type", deliveryType: k } : null;
    }));
    var platformConditions = _lodash2.default.compact(_lodash2.default.map(filters.platform, function (v, k) {
        return v ? { type: "order_platform", platform: k } : null;
    }));
    var minPrice = filters.minPrice || undefined; // 0 should be undefined
    var availability = filters.availability || {};
    var coupon = filters.coupon || {};

    var applyTo = _ChargeV2MenuFilter2.default.menuFilterToIdsFilter({ menuFilter: filters.menuFilter, menu: menu, forceItemIds: forceItemIds });
    var applyToCharges = { type: 'include', ids: filters.chargeIds || [] };

    // Display condition, constructed from the conditions
    var displayCondition = {
        "type": "and",
        "conditions": [{ type: "true" }, { type: "or", conditions: deliveryTypeConditions }, { type: "or", conditions: platformConditions }, { type: "order_delivery_time", availability: availability }]
    };

    if (coupon.couponHashCode) {
        displayCondition.conditions.push({
            type: "or",
            conditions: [{
                type: "not",
                condition: {
                    type: Boolean(coupon.state).toString()
                }
            }, {
                type: "order_coupon",
                couponHashCode: coupon.couponHashCode
            }]
        });
    }

    var templateType = function () {
        if (charge.deleted) return 'deletedDiscount';
        if (_lodash2.default.get(charge, 'filters.coupon.couponHashCode')) return charge.type + 'Coupon';
        return charge.type;
    }();

    var ret = _JsonTemplates2.default.fillTemplate({
        template: _ChargeV2Templates2.default[templateType],
        params: {
            id: charge.id,
            title: charge.title,
            description: charge.description,
            state: charge.disabled || charge.deleted ? 'closed' : 'operational',
            percent: charge.data.percent,
            amount: charge.data.amount,
            deliveryTypeConditions: deliveryTypeConditions,
            platformConditions: platformConditions,
            minPrice: minPrice,
            availability: availability,
            displayCondition: displayCondition,
            applyTo: applyTo,
            applyToCharges: applyToCharges,
            couponHashCode: coupon.couponHashCode,
            couponState: Boolean(coupon.state).toString()
        }
    });

    if (charge.deleted) {
        _Properties2.default.set(ret, 'deleted', true);
    } else if (_lodash2.default.get(charge, 'filters.menuFilter')) {
        _Properties2.default.set(ret, 'menuFilter', charge.filters.menuFilter);
    }
    if (charge.groupId) {
        _Properties2.default.set(ret, 'groupId', charge.groupId);
    }

    return cleanUp(ret);
};

self.getCountriesWithTaxes = function () {
    return ['US', 'CA', 'PR', 'GU', 'WS', 'VI', 'MP'];
};

self.hashCouponCode = _jsSha2.default;

self.isChargeRestrictedByCouponHashCode = function (charge, couponHashCode) {
    var isRestrictedBySomeCoupon = _wixRestaurantsJsSdk.helpers.Condition.checkConditionWithReasons({
        condition: charge.condition,
        couponHashCode: undefined
    }).reasons.indexOf('order_coupon') !== -1;

    var isRestrictedByGivenCoupon = _wixRestaurantsJsSdk.helpers.Condition.checkConditionWithReasons({
        condition: charge.condition,
        couponHashCode: couponHashCode
    }).reasons.indexOf('order_coupon') === -1;

    return isRestrictedBySomeCoupon && isRestrictedByGivenCoupon;
};

self.normalizeCouponCode = function (couponCode) {
    return couponCode && couponCode.replace(/[^0-9a-z\-_]/gi, '').toUpperCase();
};

self.getDefaultCouponCode = (0, _memoizeOne2.default)(function () {
    var LENGTH = 12;

    function randomString(length) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = '';
        for (var i = length; i > 0; --i) {
            result += chars[Math.floor(Math.random() * chars.length)];
        }return result;
    }

    return randomString(LENGTH);
});

var CONDITIONS = {
    'true': function _true() {
        return true;
    },
    'false': function _false() {
        return false;
    },
    'not': function not(params) {
        var condition = params.condition;
        return !checkCondition(_lodash2.default.extend(params, { condition: condition.condition }));
    },
    'and': function and(params) {
        var condition = params.condition;
        return _lodash2.default.every(condition.conditions, function (_condition) {
            return checkCondition(_lodash2.default.extend(params, { condition: _condition }));
        });
    },
    'or': function or(params) {
        var condition = params.condition;
        return _lodash2.default.some(condition.conditions, function (_condition) {
            return checkCondition(_lodash2.default.extend(params, { condition: _condition }));
        });
    },
    'order_delivery_time': function order_delivery_time(params) {
        var condition = params.condition;
        var deliveryTime = params.deliveryTime;

        var util = new availability.AvailabilityIterator({ cal: deliveryTime, availability: condition.availability || {} });
        if (!util.hasNext()) {
            console.log("AvailabilityIterator >> item availability hasNext returned false!");
            return false;
        }

        var status = util.next();
        return !(status.status === "unavailable");
    },
    'order_delivery_type': function order_delivery_type(params) {
        var condition = params.condition;
        var deliveryType = params.deliveryType;

        return condition.deliveryType === deliveryType;
    },
    'order_items_price': function order_items_price(params) {
        var condition = params.condition;
        var orderItems = params.orderItems;

        var totalApplicableItems = 0;
        _lodash2.default.each(orderItems, function (orderItem) {
            totalApplicableItems += _OrderItem2.default.getTotalPrice(orderItem);
        });

        if (condition.min && totalApplicableItems < condition.min) return false;
        if (condition.max && totalApplicableItems > condition.max) return false;

        return true;
    },
    'order_platform': function order_platform(params) {
        var condition = params.condition;
        var platform = params.platform;

        return platform === condition.platform;
    },
    'order_source': function order_source(params) {
        var condition = params.condition;
        var source = params.source;

        return source === condition.source;
    },
    'user_charge_usage': function user_charge_usage(params) {
        var condition = params.condition;

        var count = 0; // TODO!!!! (spice.MeService.getChargeUsage() || {})[condition.chargeId] || 0;
        var min = condition.min;
        if (min === null || typeof min === "undefined") {
            min = 0;
        }

        var max = condition.max;
        if (max === null || typeof max === "undefined") {
            max = Math.MAX_INT;
        }

        if (count < min) return false;
        if (count > max) return false;

        return true;
    }
};

function checkCondition(params) {
    var condition = params.condition;

    var func = CONDITIONS[condition.type] || function () {
        return false;
    };
    return func(params);
}

var OPERATORS = {
    'value': function value(params) {
        var operator = params.operator;
        return operator.value;
    },
    'min': function min(params) {
        var operator = params.operator;

        return _lodash2.default.min(_lodash2.default.map(operator.operators, function (_operator) {
            return calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        }));
    },
    'max': function max(params) {
        var operator = params.operator;

        return _lodash2.default.max(_lodash2.default.map(operator.operators, function (_operator) {
            return calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        }));
    },
    'multiply': function multiply(params) {
        var operator = params.operator;

        var numerators = 1;
        var denominators = 1;

        _lodash2.default.each(operator.numerators, function (_operator) {
            numerators *= calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        _lodash2.default.each(operator.denominators, function (_operator) {
            denominators *= calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        var result = numerators / denominators;

        return (0, _sign2.default)(result) * Math.floor(Math.abs(result) + 0.5);
    },
    'count_items': function count_items(params) {
        var operator = params.operator;
        var orderItems = params.orderItems;
        var orderCharges = params.orderCharges;

        var total = 0;

        _lodash2.default.each(orderItems, function (orderItem) {
            if (isApplicableItem(orderItem.itemId, operator.items)) {
                total = +(orderItem.count || 1);
            }
        });

        _lodash2.default.each(orderCharges, function (orderCharge) {
            if (isApplicableItem(orderCharge.chargeId, operator.charges)) {
                total++;
            }
        });

        return total;
    },
    'sum': function sum(params) {
        var operator = params.operator;

        var result = 0;

        _lodash2.default.each(operator.operators, function (_operator) {
            result += calculateOperator(_lodash2.default.extend(params, { operator: _operator }));
        });

        return result;
    },
    'sum_prices': function sum_prices(params) {
        var operator = params.operator;
        var orderItems = params.orderItems;
        var orderCharges = params.orderCharges;

        // Get all applicable items' price in a sorted list
        var applicableItems = _lodash2.default.flatten(_lodash2.default.compact(_lodash2.default.map(orderItems, function (orderItem) {
            if (!isApplicableItem(orderItem.itemId, operator.items)) {
                return null;
            }
            return _lodash2.default.map(_lodash2.default.range(orderItem.count || 1), function () {
                return _OrderItem2.default.getTotalPrice(orderItem) / (orderItem.count || 1);
            });
        })));

        // Get all applicable items' price in a sorted list
        var applicableCharges = _lodash2.default.flatten(_lodash2.default.compact(_lodash2.default.map(orderCharges, function (orderCharge) {
            if (!isApplicableItem(orderCharge.chargeId, operator.charges)) {
                return null;
            }
            return orderCharge.amount;
        })));

        var applicable = (0, _lodash2.default)(applicableItems).concat(applicableCharges).value().sort(function (x, y) {
            return x - y;
        });

        // Re-calculate Y
        var max = Math.min(operator.maxCount || Number.MAX_VALUE, applicable.length);

        // Ensure there's the right amount of items
        if (max < 0) return 0;

        return _lodash2.default.reduce(applicable.splice(0, max), function (memo, num) {
            return memo + num;
        }, 0);
    }
};

function calculateOperator(params) {
    var operator = params.operator;

    var func = OPERATORS[operator.type] || function () {
        return 0;
    };
    return func(params);
};

function isApplicableItem(itemId, idsFilter) {
    if (!idsFilter) return false;

    if ((idsFilter.type || "include") === "include") {
        return _lodash2.default.includes(idsFilter.ids, itemId);
    } else {
        return !_lodash2.default.includes(idsFilter.ids, itemId);
    }
}

function cleanUp(charge) {
    var ret = _lodash2.default.cloneDeep(charge);

    if (!ret.disabled) {
        delete ret.disabled;
    }

    if (!ret.deleted) {
        delete ret.deleted;
    }

    var omitByRecursively = function omitByRecursively(value) {

        if (_lodash2.default.isArray(value)) {
            return _lodash2.default.compact(_lodash2.default.map(value, omitByRecursively));
        } else if (_lodash2.default.isObject(value)) {
            var r = _lodash2.default.omitBy(value, _lodash2.default.isUndefined);
            _lodash2.default.each(r, function (v, k) {
                r[k] = omitByRecursively(v);
            });
            return r;
        } else {
            return value;
        }
    };

    return omitByRecursively(ret);
}

exports.default = self;


function migrateOldTaxIfNeeded(charge) {
    // This mostly just turns taxes using the old (complicated) format into
    // taxes that use the new (also complicated) format
    // Arbitrarily detecting that this is an old tax by checking if it has the correct number of conditions

    // 13.07.17: Due to legacy systems containing weird other illegal taxes, added several more tests to see
    // if this should just be ignored - T.M
    var isWeirdLegacyTax = charge.type == 'tax' && !(charge.operator && charge.operator.numerators && charge.operator.numerators[0] && charge.operator.numerators[0].items && charge.operator.numerators[1].value);

    if (charge.type == 'tax' && !(charge.condition && charge.condition.type == 'and' && (charge.condition.conditions || []).length == 4) && !isWeirdLegacyTax) {
        var deliveryTypeConditions = _lodash2.default.map(['delivery', 'takeout'], function (val) {
            return { type: 'order_delivery_type', deliveryType: val };
        });

        var ret = _JsonTemplates2.default.fillTemplate({
            template: _ChargeV2Templates2.default.tax,
            params: {
                id: charge.id,
                title: charge.title,
                description: charge.description,
                deliveryTypeConditions: deliveryTypeConditions,
                applyTo: charge.operator.numerators[0].items,
                percent: charge.operator.numerators[1].value,
                state: charge.state || 'operational'
            }
        });

        ret.properties = charge.properties;

        return ret;
    } else {
        return charge;
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/ChargeV2.js
// module id = 125
// module chunks = 0